<template>
    <div class="wp">
        <!-- <p></p> -->
        <div class="imgDiv">
            <img src="../../assets/wp/img/wp_03.png" alt />
        </div>
        <div class="wp_top">
            <popup ref="popup1" :coluMns="columns" :defaultIndex="1" :Value="'题名或关键词'"></popup>
            <popup ref="popup2" :coluMns="columns" :defaultIndex="2" :Value="'题名'"></popup>
            <popup ref="popup3" :coluMns="columns" :defaultIndex="3" :Value="'关键词'"></popup>
            <popup ref="popup4" :coluMns="columns" :defaultIndex="4" :Value="'文摘'"></popup>
            <popup ref="popup5" :coluMns="columns" :defaultIndex="5" :Value="'作者'"></popup>
        </div>
        <div class="wp_bottom">
            <div>
                <button :class="{ active: true != buttonShow, btnL: true }" @click="button($event)">
                    时间段
                </button>
                <button :class="{ active: true == buttonShow, btnR: true }" @click="button($event)">
                    更新时间
                </button>
            </div>
            <div v-show="true != buttonShow">
                <van-field
                    readonly
                    clickable
                    :value="yearStart"
                    placeholder="开始时间"
                    @click="year1 = true"
                    style="width:31%;float:left;padding-left:0px;"
                />
                <van-popup v-model="year1" position="bottom">
                    <van-datetime-picker
                        @cancel="year1 = false"
                        v-model="currentDate"
                        type="date"
                        :min-date="minStaet"
                        :max-date="maxStaet"
                        @confirm="staetConfirm"
                    />
                </van-popup>
                <span style="float:left;">至</span>
                <van-field readonly clickable :value="yearEnd" placeholder="结束时间" @click="year2 = true" style="width:31%;float:left" />
                <van-popup v-model="year2" position="bottom">
                    <van-datetime-picker
                        @cancel="year2 = false"
                        v-model="currentDate"
                        type="date"
                        :min-date="minEnd"
                        :max-date="maxEnd"
                        @confirm="endConfirm"
                    />
                </van-popup>
            </div>
            <div v-show="true == buttonShow">
                <van-field
                    readonly
                    clickable
                    :value="PTvalue"
                    placeholder="请选择更新时间"
                    @click="PTshowPicker = true"
                    style="width:100%;float:left;padding-left:0px;"
                />
                <van-popup v-model="PTshowPicker" position="bottom">
                    <van-picker show-toolbar :columns="fulltext" @cancel="PTshowPicker = false" @confirm="onConfirm" />
                </van-popup>
            </div>
        </div>
        <van-button type="info" @click="retrieval()">检索</van-button>
    </div>
</template>
<script>
// import { Toast } from 'vant'
import popup from "../../components/popup";

export default {
    data() {
        return {
            columns: [
                "任意字段",
                "题名或关键词",
                "题名",
                "关键词",
                "文摘",
                "作者",
                "第一作者",
                "机构",
                "刊名",
                "分类号",
                "参考文献",
                "作者简介",
                "基金资助",
                "栏目信息"
            ],
            fulltext: ["一个月内", "三个月内", "半年内", "一年内", "当年内"],
            PTshowPicker: false,
            PTvalue: "",
            yearStart: "",
            yearEnd: "",
            year1: false,
            year2: false,
            dtShowPicker: false,
            maxStaet: new Date(),
            minStaet: new Date(1900, 0, 1),
            minEnd: new Date(),
            maxEnd: new Date(),
            currentDate: new Date(),
            buttonShow: false
        };
    },
    components: {
        popup
    },
    mounted() {
        //     localStorage.setItem("access-user", this.$route.query.token);
        this.$store.dispatch("actionsHead", { type: true, title: "维普资讯", iconType: false });
    },
    methods: {
        button(e) {
            if (e.target.innerText == "时间段") {
                this.buttonShow = false;
            } else {
                this.buttonShow = true;
            }
        },
        onConfirm(value) {
            this.PTvalue = value;
            this.PTshowPicker = false;
        },
        staetConfirm(value) {
            this.yearStart = value.getFullYear() + "/" + (value.getMonth() + 1) + "/" + value.getDate();
            this.year1 = false;
            this.minEnd = new Date(value.getFullYear(), value.getMonth(), value.getDate());
        },
        endConfirm(value) {
            this.yearEnd = value.getFullYear() + "/" + (value.getMonth() + 1) + "/" + value.getDate();
            this.year2 = false;
            this.maxStaet = new Date(value.getFullYear(), value.getMonth(), value.getDate());
        },
        retrieval() {
            var data = new Object();

            if (this.$refs.popup1.input != "") {
                data.input1 = this.$refs.popup1.input; // 输入一
                data.sel1 = this.sel(this.$refs.popup1.value); // 参数一
            }
            if (this.$refs.popup2.input != "") {
                data.input2 = this.$refs.popup2.input; // 输入二
                data.sel2 = this.sel(this.$refs.popup2.value); // 参数二
            }
            if (this.$refs.popup3.input != "") {
                data.input3 = this.$refs.popup3.input; // 输入三
                data.sel3 = this.sel(this.$refs.popup3.value); // 参数三
            }
            if (this.$refs.popup4.input != "") {
                data.input4 = this.$refs.popup4.input; // 输入四
                data.sel4 = this.sel(this.$refs.popup4.value); // 参数四
            }
            if (this.$refs.popup5.input != "") {
                data.input5 = this.$refs.popup5.input; // 输入五
                data.sel5 = this.sel(this.$refs.popup5.value); // 参数五
            }
            if (this.$refs.popup5.input != "") {
                data.input5 = this.$refs.popup5.input; // 输入五
                data.sel5 = this.sel(this.$refs.popup5.value); // 参数五
            }
            if (this.PTvalue != "") {
                data.updateTime = this.PTvaluefun(this.PTvalue); // 更新时间
            }
            if (this.yearStart != "" || this.yearEnd != "") {
                data.yearStart = this.yearStart; // 开始时间
                data.yearEnd = this.yearEnd; // 结束时间
            }
            data.page = 1; //分页

            this.$router.push({
                path: "/wpList",
                query: data
            });
        },
        sel(selInp) {
            if (selInp == "任意字段") {
                return "U";
            } else if (selInp == "题名或关键词") {
                return "M";
            } else if (selInp == "题名") {
                return "T";
            } else if (selInp == "关键词") {
                return "K";
            } else if (selInp == "文摘") {
                return "R";
            } else if (selInp == "作者") {
                return "A";
            } else if (selInp == "第一作者") {
                return "F";
            } else if (selInp == "机构") {
                return "S";
            } else if (selInp == "刊名") {
                return "J";
            } else if (selInp == "分类号") {
                return "C";
            } else if (selInp == "参考文献") {
                return "Y";
            } else if (selInp == "作者简介") {
                return "Z";
            } else if (selInp == "基金资助") {
                return "I";
            } else if (selInp == "栏目信息") {
                return "L";
            }
        },
        PTvaluefun(value) {
            if (value == "一个月内") {
                return 1;
            } else if (value == "三个月内") {
                return 2;
            } else if (value == "半年内") {
                return 3;
            } else if (value == "一年内") {
                return 4;
            } else if (value == "当年内") {
                return 5;
            }
        }
    }
};
</script>
<style lang="less">
.wp {
    background: #fff;

    .imgDiv {
        background: #fff;
        border-bottom: 1px solid #e3e3e3;
        text-align: center;
        margin-top: 0.8rem;

        img {
            width: 30%;
            margin: 1rem 0;
        }
    }

    .wp_top {
        > div {
            overflow: hidden;

            .van-field {
                width: 68%;
                float: left;

                .van-cell__value {
                    border-bottom: 1px solid #e3e3e3;
                    padding: 0 0 0 0.5rem;
                }
            }

            .van-cell--clickable {
                width: 30%;
                background: url("../../publics/image/07.png") right center no-repeat;

                .van-cell__value {
                    border: 0;
                }
            }
        }
    }

    .wp_bottom {
        line-height: 1.5rem;
        padding-top: 0.8rem;
        margin-top: 0.8rem;
        background: #f3f3f3;

        > div {
            overflow: hidden;
        }

        span {
            font-size: 14px;
        }

        .label {
            float: left;
            font-size: 14px;
            padding-left: 16px;
            width: 30%;

            span {
                padding: 0 0 0 0.5rem;
            }
        }

        .van-cell--clickable {
            .van-field__control {
                background: url("../../publics/image/07.png") 95% center no-repeat;
                border: 1px solid #dadada;
                padding: 0 0.5rem;
                border-radius: 2px;
            }
        }

        .van-field__control {
            border-bottom: 1px solid #e3e3e3;
            border-radius: 0;
            width: 97%;
        }

        > div {
            background: #fff;
            padding-top: 1rem;
            padding-left: 1rem;

            > span {
                line-height: 2.3rem;
            }

            .active {
                background: #0d60a4;
                color: #fff;
            }

            .btnL {
                border-right: 0;
                border-top-left-radius: 3px;
                border-bottom-left-radius: 3px;
            }

            .btnR {
                border-left: 0;
                border-top-right-radius: 3px;
                border-bottom-right-radius: 3px;
            }

            > button {
                width: 4rem;
                height: 2rem;
                font-size: 0.7rem;
                border: 1px solid #d9d9d9;
                background: #fff;
            }
        }
    }

    > button {
        width: 81%;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 2rem;
        background-color: #0d60a4;
    }
}
</style>
